import { lazy } from "react";

// Argon Dashboard 2 MUI components
import ArgonBox from "components/ArgonBox";

// Layouts cargados bajo demanda (code-splitting por ruta)
const AgregarUsuarios = lazy(() => import("layouts/agregarUsuario"));
const SignIn = lazy(() => import("layouts/authentication/sign-in"));
const Comprobantes = lazy(() => import("layouts/comprobantes"));
const Dashboard = lazy(() => import("layouts/dashboard"));
const Historial = lazy(() => import("layouts/historial"));
const Transferencias = lazy(() => import("layouts/transferencias"));
const AgregarEmpresas = lazy(() => import("layouts/agregarEmpresa"));
const Empresas = lazy(() => import("layouts/empresas"));
const Multa = lazy(() => import("layouts/multa"));
const CrearReclamo = lazy(() => import("layouts/crearReclamo"));
const GestionarReclamos = lazy(() => import("layouts/gestionarReclamos"));
const Suscripciones = lazy(() => import("layouts/suscripciones"));
const Planes = lazy(() => import("layouts/planes"));
const Logs = lazy(() => import("layouts/logs"));
const Dispositivos = lazy(() => import("layouts/dispositivos"));
const Usuarios = lazy(() => import("layouts/usuarios"));
const UsuarioDetalle = lazy(() => import("layouts/usuarios/UsuarioDetalle"));
const PushNotifications = lazy(() => import("layouts/enviarPush"));
const PushEnviadas = lazy(() => import("layouts/pushEnviadas"));
const ValidarCuentaBancaria = lazy(() => import("layouts/validarCuentas/ValidarCuentaBancaria"));
const AgregarAliado = lazy(() => import("layouts/agregarAliado"));
const Aliados = lazy(() => import("layouts/aliados"));
const AliadoDetalle = lazy(() => import("layouts/aliados/AliadoDetalle"));
const PartnersIndex = lazy(() => import("layouts/partners"));
const CrearPartner = lazy(() => import("layouts/partners/CrearPartner"));
const PartnerDetalle = lazy(() => import("layouts/partners/PartnerDetalle"));
const PartnershipsIndex = lazy(() => import("layouts/partnerships"));
const CrearPartnership = lazy(() => import("layouts/partnerships/CrearPartnership"));
const PartnershipDetalle = lazy(() => import("layouts/partnerships/PartnershipDetalle"));
const AprobarCambios = lazy(() => import("layouts/aprobarCambios"));
const CrearDescuento = lazy(() => import("layouts/descuentos/crearDescuento"));
const GestionarDescuentos = lazy(() => import("layouts/descuentos/gestionarDescuentos"));
const EnvioCredenciales = lazy(() => import("layouts/envioCredenciales"));

// Importar iconos SVG
import InicioIcon from "assets/icons/inicio.svg";
import HistorialIcon from "assets/icons/historial.svg";
import PushIcon from "assets/icons/push.svg";
import PushEnviadasIcon from "assets/icons/push-enviadas.svg";
import SuscripcionesIcon from "assets/icons/suscripciones.svg";
import PlanesIcon from "assets/icons/planes.svg";
import AgregarIcon from "assets/icons/agregar.svg";
import UsuariosIcon from "assets/icons/usuarios.svg";
import AgregarEmpresaIcon from "assets/icons/agregar-empresa.svg";
import EmpresasIcon from "assets/icons/empresas.svg";
import MultaIcon from "assets/icons/multa.svg";
import ComprobantesIcon from "assets/icons/comprobantes.svg";
import ReclamoIcon from "assets/icons/reclamo.svg";
import GestionarReclamosIcon from "assets/icons/gestionar-reclamos.svg";
import LogsIcon from "assets/icons/logs.svg";

import { LiaUserCheckSolid } from "react-icons/lia";
import { RiDiscountPercentLine } from "react-icons/ri";
import { BsPersonLock } from "react-icons/bs";
import { CgCheckR } from "react-icons/cg";
import { MdAssignment, MdHandshake, MdOutlineDiscount, MdOutlinePhoneIphone } from "react-icons/md";

const routes = [
  {
    type: "route",
    name: "Inicio",
    key: "dashboard",
    route: "/dashboard",
    icon: <ArgonBox component="img" src={InicioIcon} alt="Inicio" width="18px" height="18px" />,
    component: <Dashboard />,
    includeInSidebar: true,
  },
  
  {
    type: "route",
    name: "PayOuts",
    key: "transferencias-pendientes",
    route: "/transferencias-pendientes",
    icon: (
      <ArgonBox component="i" color="#000000" fontSize="14px" className="ni ni-money-coins" />
    ),
    component: <Transferencias />,
    includeInSidebar: false,
  },

  {
    type: "route",
    name: "Historial",
    key: "historial",
    route: "/historial",
    icon: <ArgonBox component="img" src={HistorialIcon} alt="Historial" width="18px" height="18px" />,
    component: <Historial />,
    includeInSidebar: true,
  },
   
  { type: "title", title: "Usuarios", key: "usuarios-section",     includeInSidebar: true, },
  

  {
    type: "route",
    name: "Alta Usuario",
    key: "alta-usuario",
    route: "/alta-usuario",
    icon: <ArgonBox component="img" src={AgregarIcon} alt="Alta Usuario" width="18px" height="18px" />,
    component: <AgregarUsuarios />,
    includeInSidebar: true,
  },
  {
    type: "route",
    name: "Envío de Credenciales",
    key: "envio-credenciales",
    route: "/envio-credenciales",
    icon: <BsPersonLock size={18} />,
    component: <EnvioCredenciales />,
    includeInSidebar: true,
  },
  {
    type: "route",
    name: "Usuarios",
    key: "usuarios",
    route: "/usuarios",
    icon: <ArgonBox component="img" src={UsuariosIcon} alt="Usuarios" width="18px" height="18px" />,
    component: <Usuarios />,
    includeInSidebar: true,
  },
  {
    type: "route",
    name: "Aprobar Cambios",
    key: "aprobar-cambios",
    route: "/aprobar-cambios",
    icon: <ArgonBox component={LiaUserCheckSolid} color="#000000" fontSize="18px" />,
    component: <AprobarCambios />,
    includeInSidebar: true,
  },



  {
    type: "route",
    name: "Validar Cuenta",
    key: "validar-cuenta",
    route: "/validar-cuenta",
    icon: <CgCheckR style={{ width: 18, height: 18, minWidth: 18, minHeight: 18 }} />,
    component: <ValidarCuentaBancaria />,
    includeInSidebar: true,
  },
  {
    type: "route",
    name: "Usuarios",
    key: "usuario-detalle",
    route: "/usuario/:id",
    component: <UsuarioDetalle />, 
    includeInSidebar: false,
  },

  
  {
    type: "route",
    name: "Sign In",
    key: "sign-in",
    route: "/authentication/sign-in",
    icon: (
      <ArgonBox component="i" color="#000000" fontSize="14px" className="ni ni-single-copy-04" />
    ),
    component: <SignIn />,
    includeInSidebar: false,
  },
  { type: "title", title: "Empresas", key: "empresas-section",     includeInSidebar: true, },


  {
    type: "route",
    name: "Alta Empresa",
    key: "alta-empresa",
    route: "/alta-empresa",
    icon: <ArgonBox component="img" src={AgregarEmpresaIcon} alt="Alta Empresa" width="18px" height="18px" />,
    component: <AgregarEmpresas />,
    includeInSidebar: true,
  },

  {
    type: "route",
    name: "Empresas",
    key: "empresas",
    route: "/empresas",
    icon: <ArgonBox component="img" src={EmpresasIcon} alt="Empresas" width="18px" height="18px" />,
    component: <Empresas />,
    includeInSidebar: true,
  },

  {
    type: "route",
    name: "Multa",
    key: "multa",
    route: "/multa",
    icon: <ArgonBox component="img" src={MultaIcon} alt="Multa" width="18px" height="18px" />,
    component: <Multa />,
    includeInSidebar: true,
  },
  {
    type: "route",
    name: "Comprobantes",
    key: "comprobantes",
    route: "/comprobantes",
    icon: <ArgonBox component="img" src={ComprobantesIcon} alt="Comprobantes" width="18px" height="18px" />,
    component: <Comprobantes />,
    includeInSidebar: true,
  },

  { type: "title", title: "Suscripciones", key: "suscripciones-section",     includeInSidebar: true, },


  {
    type: "route",
    name: "Suscripciones",
    key: "suscripciones",
    route: "/suscripciones",
    icon: <ArgonBox component="img" src={SuscripcionesIcon} alt="Suscripciones" width="18px" height="18px" />,
    component: <Suscripciones />,
    includeInSidebar: true,
  },

  {
    type: "route",
    name: "Planes",
    key: "planes",
    route: "/planes",
    icon: <ArgonBox component="img" src={PlanesIcon} alt="Planes" width="18px" height="18px" />,
    component: <Planes />,
    includeInSidebar: true,
  },
 

  { type: "title", title: "Notificaciones", key: "notifications-section",     includeInSidebar: true, },
  {
    type: "route",
    name: "Enviar Push",
    key: "enviar-push",
    route: "/enviar-push",
    icon: <ArgonBox component="img" src={PushIcon} alt="Enviar Push" width="18px" height="18px" />,
    component: <PushNotifications />,
    includeInSidebar: true,
  },
{
  type: "route",
  name: "Push Enviadas",
  key: "push-log",
  route: "/push-log",
  icon: <ArgonBox component="img" src={PushEnviadasIcon} alt="Push Enviadas" width="18px" height="18px" />,
  component: <PushEnviadas />,
  includeInSidebar: true,
},
{ type: "title", title: "Support", key: "support-section",     includeInSidebar: true, },
{
  type: "route",
  name: "Registrar Reclamo",
  key: "crear-reclamo",
  route: "/crear-reclamo",
  icon: <ArgonBox component="img" src={ReclamoIcon} alt="Registrar Reclamo" width="18px" height="18px" />,
  component: <CrearReclamo />,
  includeInSidebar: true,
},
{
  type: "route",
  name: "Gestionar Reclamos",
  key: "gestionar-reclamos",
  route: "/gestionar-reclamos",
  icon: <ArgonBox component="img" src={GestionarReclamosIcon} alt="Gestionar Reclamos" width="18px" height="18px" />,
  component: <GestionarReclamos />,
  includeInSidebar: true,
},

{ type: "title", title: "Descuentos", key: "descuentos-section",     includeInSidebar: true, },
{
  type: "route",
  name: "Crear Descuento",
  key: "crear-descuento",
  route: "/crear-descuento",
  icon: <RiDiscountPercentLine size={18} />,
  component: <CrearDescuento />,
  includeInSidebar: true,
},
{
  type: "route",
  name: "Gestionar Descuentos",
  key: "descuentos",
  route: "/descuentos",
  icon: <MdOutlineDiscount size={18} />,
  component: <GestionarDescuentos />,
  includeInSidebar: true,
},
{ type: "title", title: "Aliados", key: "aliados-section",     includeInSidebar: true, },
  

{
  type: "route",
  name: "Alta Aliado",
  key: "alta-aliado",
  route: "/alta-aliado",
  icon: <ArgonBox component="img" src={AgregarIcon} alt="Alta Aliado" width="18px" height="18px" />,
  component: <AgregarAliado />,
  includeInSidebar: true,
},
{
  type: "route",
  name: "Aliados",
  key: "aliados",
  route: "/aliados",
  icon: <ArgonBox component="img" src={UsuariosIcon} alt="Aliados" width="18px" height="18px" />,
  component: <Aliados />,
  includeInSidebar: true,
},
{
  type: "route",
  name: "Aliado Detalle",
  key: "aliado-detalle",
  route: "/aliado/:id",
  component: <AliadoDetalle />, 
  includeInSidebar: false,
},

{ type: "title", title: "Partners", key: "partners-section",     includeInSidebar: true, },
{
  type: "route",
  name: "Crear Partner",
  key: "crear-partner",
  route: "/partners/nuevo",
  icon: <ArgonBox component="img" src={AgregarIcon} alt="Crear Partner" width="18px" height="18px" />,
  component: <CrearPartner />,
  includeInSidebar: true,
},
{
  type: "route",
  name: "Partners",
  key: "partners",
  route: "/partners",
  icon: <MdHandshake size={20} color="#111" />,
  component: <PartnersIndex />,
  includeInSidebar: true,
},
{
  type: "route",
  name: "Partner Detalle",
  key: "partner-detalle",
  route: "/partners/:id",
  component: <PartnerDetalle />,
  includeInSidebar: false,
},
{ type: "title", title: "Partnerships", key: "partnerships-section",     includeInSidebar: true, },
{
  type: "route",
  name: "Nuevo Partnership",
  key: "crear-partnership",
  route: "/partnerships/nuevo",
  icon: <ArgonBox component="img" src={AgregarIcon} alt="Nuevo partnership" width="18px" height="18px" />,
  component: <CrearPartnership />,
  includeInSidebar: true,
},
{
  type: "route",
  name: "Partnerships",
  key: "partnerships",
  route: "/partnerships",
  icon: <MdAssignment size={20} color="#111" />,
  component: <PartnershipsIndex />,
  includeInSidebar: true,
},
{
  type: "route",
  name: "Partnership Detalle",
  key: "partnership-detalle",
  route: "/partnerships/:id",
  component: <PartnershipDetalle />,
  includeInSidebar: false,
},
  
  { type: "title", title: "Dispositivos", key: "dispositivos-section",     includeInSidebar: true, },
  {
    type: "route",
    name: "Dispositivos",
    key: "dispositivos",
    route: "/dispositivos",
    icon: <ArgonBox component={MdOutlinePhoneIphone} color="#000000" fontSize="18px" />,
    component: <Dispositivos />,
    includeInSidebar: true,
  },
 





  { type: "title", title: "Logs", key: "logs-section",     includeInSidebar: true, },
  {
    type: "route",
    name: "Logs",
    key: "logs",
    route: "/logs",
    icon: <ArgonBox component="img" src={LogsIcon} alt="Logs" width="18px" height="18px" />,
    component: <Logs />,
    includeInSidebar: true,
  },
];

export default routes;
